// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-Components-GridTableCommon-GridTable-module__tableHeader--L61aI{box-sizing:border-box}`, "",{"version":3,"sources":["webpack://./src/Components/GridTableCommon/GridTable.module.scss"],"names":[],"mappings":"AAAA,qEACE,qBAAA","sourcesContent":[".tableHeader {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export var tableHeader = `src-Components-GridTableCommon-GridTable-module__tableHeader--L61aI`;
export default ___CSS_LOADER_EXPORT___;
